export function getProvider(provider) {
  switch (provider) {
    case 'filepond':
      var _require = require('./filepond/filepond-provider'),
        FilePondProvider = _require["default"];
      return {
        name: 'filepond',
        Component: FilePondProvider
      };
  }
}